import React from "react";
import LazyImage from "../../molecules/layout/Images/LazyImage";
import Image from "@image";

const testimonials = [
    {
        customer_name: "Joe Ocholla",
        location: "Rongau",
        image: "images/testimonials/JoeOchollaCaseStudy.jpg",
        testimony:
            "I settled any doubts by buying plans and drawings for my home at their offices. During construction they give honest advice, onsite and on email with photos to help me make informed decisions. I think their project tools could prove useful too.",
        blog_post:
            "/blog/posts/inuua-case-study-1-joe-ocholla-rangau-ongata-rongai-town/",
        plan: "",
    },
    {
        customer_name: "D. Nganga",
        location: "Juja",
        image: "images/testimonials/DNgangaCaseStudy.jpg",
        testimony:
            "The Inuua Team took the time to help us understand the plan we liked and made small adjustments as required within a few days of payment. We appreciate their honesty and dedication to service.",
        blog_post: "",
        plan: "4232 4 Bedroom Maisonette House Plan",
    },
];

function Testimonials() {
    return (
        <section id="testimonials" className="section section-lg pt-lg-6 pt-3">
            <div className="container">
                <div className="justify-content-start mb-5 mb-lg-5">
                    <div className="col-12 col-md-8">
                        <h2 className="h2 font-weight-bolder mb-4">
                            Happy customers
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 testimonials-carousel">
                            <div
                                id="myCarousel"
                                className="carousel slide"
                                data-ride="carousel"
                            >
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <div className="row">
                                            {/*  */}
                                            {testimonials.map(
                                                (testimonial, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="col-sm-6"
                                                    >
                                                        <div className="media">
                                                            <div className="card shadow-soft border-light">
                                                                <div className="card-header p-0 card-header-carousel">
                                                                    <div className="col-md-12 px-0">
                                                                        <div className="row no-gutters pt-2 pl-2">
                                                                            <div className="flex-1 pt-3">
                                                                                <div className="pt-0">
                                                                                    <p className="overview mb-0">
                                                                                        <b>
                                                                                            {
                                                                                                testimonial.customer_name
                                                                                            }
                                                                                        </b>
                                                                                    </p>
                                                                                </div>
                                                                                <div>
                                                                                    <p>
                                                                                        {
                                                                                            testimonial.location
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="col-md-12 px-0"
                                                                        style={{
                                                                            height: "20rem",
                                                                        }}
                                                                    >
                                                                        <Image
                                                                            src={`/${testimonial.image}`}
                                                                            layout="fill"
                                                                            quality={
                                                                                50
                                                                            }
                                                                            className="card-img-top rounded-0 w-100"
                                                                            alt={`Using Inuua Tujenge Case Study - Testimanial by ${testimonial.customer_name} for ${testimonial.plan} ${testimonial.location}`}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="card-body px-2 pt-3 pb-3">
                                                                    <div className="media-body">
                                                                        <div className="testimonial">
                                                                            <p>
                                                                                {
                                                                                    testimonial.testimony
                                                                                }{" "}
                                                                                {testimonial.blog_post &&
                                                                                    testimonial
                                                                                        .blog_post
                                                                                        .length >
                                                                                        0 && (
                                                                                        <a
                                                                                            className="text-underline"
                                                                                            href={
                                                                                                testimonial.blog_post
                                                                                            }
                                                                                        >
                                                                                            Read
                                                                                            the
                                                                                            full
                                                                                            case
                                                                                            study
                                                                                        </a>
                                                                                    )}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonials;
